import { fmt } from "../../lib/api";

export default function SectionCard({ title, total, children }) {
  return (
    <div className="rounded-2xl border border-border bg-card p-5 md:p-6 animate-fadeInUp">
      <div className="flex items-center justify-between gap-4 mb-4">
        <h3 className="font-display text-xl font-semibold text-foreground">{title}</h3>
        {total !== undefined && total !== null && (
          <div className="text-right flex-shrink-0">
            <div className="text-[10px] uppercase tracking-wider text-muted-foreground">Ara Toplam</div>
            <div className="font-display text-xl font-semibold text-primary tabular-nums">
              {fmt(total, 3)} <span className="text-xs text-muted-foreground font-normal">tCO₂e</span>
            </div>
          </div>
        )}
      </div>
      {children}
    </div>
  );
}
